import type { QuoteDocument, QuoteStatus, ValidityDays } from '../types'
import { calcTotals, createLineFromProduct, recalcLine } from './pricing'

const STATUSES: QuoteStatus[] = ['DRAFT', 'SENT', 'AWAITING', 'APPROVED', 'LOST', 'CANCELLED']
const DAYS: ValidityDays[] = [3, 5, 7, 15, 30]

export function createFakeQuotes(total = 50): QuoteDocument[] {
  const now = Date.UTC(2026, 3, 1)
  const quotes: QuoteDocument[] = []

  for (let i = 0; i < total; i++) {
    const itemCount = 1 + (i % 4)
    const items = Array.from({ length: itemCount }, (_, idx) => {
      const purchase = 100 + i * 17 + idx * 40
      return createLineFromProduct({
        productId: `prod-${String(((i + idx) % 100) + 1).padStart(3, '0')}`,
        description: `Item orçamento ${i + 1}.${idx + 1}`,
        purchasePrice: purchase,
        salePrice: purchase * (1.2 + (idx % 3) * 0.1),
        sortOrder: idx,
      })
    })

    const discountPercent = i % 5 === 0 ? 5 : 0
    const discountValue = i % 7 === 0 ? 50 : 0
    const freight = i % 4 === 0 ? 35 : 0
    const totals = calcTotals(items, discountPercent, discountValue, freight)
    const created = new Date(now - i * 86_400_000).toISOString()

    quotes.push({
      id: `quote-${String(i + 1).padStart(3, '0')}`,
      code: `ORC-${String(2026000 + i + 1)}`,
      title: `Orçamento #${i + 1}`,
      status: STATUSES[i % STATUSES.length]!,
      customerId: i % 3 === 0 ? null : `cust-${String((i % 30) + 1).padStart(3, '0')}`,
      customerName: i % 3 === 0 ? null : `Cliente Demo ${(i % 30) + 1}`,
      validUntilDays: DAYS[i % DAYS.length]!,
      quoteDate: created,
      discountPercent,
      discountValue,
      freight,
      notes: i % 6 === 0 ? 'Orçamento com condições especiais Master Informática.' : '',
      items: items.map((item, idx) => recalcLine({ ...item, sortOrder: idx })),
      totals,
      snapshotJson: null,
      pdfUrl: null,
      createdAt: created,
      updatedAt: created,
    })
  }

  return quotes
}

export function nextQuoteCode(existing: QuoteDocument[]): string {
  const max = existing.reduce((acc, q) => {
    const n = Number(q.code.replace(/\D/g, ''))
    return Number.isFinite(n) ? Math.max(acc, n) : acc
  }, 2026000)
  return `ORC-${max + 1}`
}
